import { updateIncomeModalContainerId } from 'const/modalContainerId'
import getMFEConfig from 'helpers/getMFEConfig'
import { triggerOnCloseAnalytics } from 'helpers/triggerOnCloseAnalytics'
import { useAtom, useAtomValue } from 'jotai'
import { IncomeCaptureRoot } from 'profile-mfe'
import { ReactElement, Suspense, lazy } from 'react'
import { modalStatusAtom, selectedAccountAtom } from 'store/atoms'
import { analyticsConfig } from 'syf-js-utilities/helpers/triggerAnalyticsEvent'
import ErrorBoundary from 'ui/patterns/ErrorBoundary'
import Loader from 'authorization-module/lib/ui/atoms/Loader'
import isFeatureFlagEnabled from 'helpers/isFeatureFlagEnabled'
import { getBrandRefreshPhase } from 'helpers/getBrandRefreshPhase'

/* eslint-disable import/no-unresolved */
const IncomeCaptureRuntime = lazy(
  () => import('profile-mfe-runtime-income/income-capture')
)

const UpdateIncomeModal = (): ReactElement => {
  const [{ modalId }, updateModalStatus] = useAtom(modalStatusAtom)
  const selectedAccount = useAtomValue(selectedAccountAtom)

  const config = getMFEConfig('mfe')

  const handleCloseModal = () => {
    updateModalStatus('', '')
    triggerOnCloseAnalytics()
  }

  const isModalOpen = modalId === 'UpdateIncome'

  const props = {
    config,
    selectedAccountId: selectedAccount,
    containerId: updateIncomeModalContainerId(selectedAccount),
    isModalOpen,
    handleClose: handleCloseModal,
    analyticsDefaults: analyticsConfig.defaults,
    featureFlags: {
      brandRefreshPhase: getBrandRefreshPhase()
    }
  }

  if (!isModalOpen) return null

  if (isFeatureFlagEnabled('isIncomeCaptureRuntimeEnabled')) {
    return (
      <ErrorBoundary customFallback={<IncomeCaptureRoot {...props} />}>
        <Suspense fallback={<Loader />}>
          <IncomeCaptureRuntime {...props} />
        </Suspense>
      </ErrorBoundary>
    )
  }

  return <IncomeCaptureRoot {...props} />
}

export default UpdateIncomeModal
